export const PRODUCTS_ACTION_TYPES = {
    SET_PRODUCTS: 'product/SET_PRODUCTS',
  };